 <template>    
    
  <header >
    
        <div class="top-header"> 
          <div class="container">
      <div class="row">       
            <div class="col-md-2 col-xs-12 logo">
              <a href="#"><img src="/img/logo-bgp.svg" alt="Bảo Gia Phú"></a>
              <p class="slogan hidden-lg hidden-md">                                                               
                <marquee behavior="alternate" width="10%"></marquee>Nhà cung cấp vật tư M&E<marquee behavior="alternate" width="10%"></marquee> 
              </p>
            </div>
            <div class="col-md-10 hidden-sm">
              <div class="ten-cty">
                <span>CÔNG TY TNHH ĐẦU TƯ THƯƠNG MẠI BẢO GIA PHÚ</span>                        
                <p class="slogan">
                  <marquee behavior="alternate" style=" padding: 37px 0;">Giá trị tạo nên chữ Tín</marquee>                                                
                  <marquee behavior="alternate" width="10%"></marquee>Nhà cung cấp vật tư M&E<marquee behavior="alternate" width="10%"></marquee> 
                </p>
              </div>                        
            </div>                
        </div>
       
      <nav class="navbar navbar-expand-lg navbar-light">        
        <div class="mb-search">
            <form class="form-inline hidden-lg hidden-md">
                <input class="form-control mr-sm-2" type="search" placeholder="Search" aria-label="Search">
              <button class="btn btn-outline-success my-2 my-sm-0" type="submit"><i class="fa fa-search"></i></button>
            </form>
        </div>
        <div class="collapse navbar-collapse" >
          <RwvMenu :categories="categories"/>          
        </div>

        <Slide width="300" noOverlay >  
          <div class="title-m"><b>MENU</b></div>                
          <div class="main-menu">
            <RwvMenu :categories="categories"/>
          </div>
        </Slide>
      </nav>
      </div>
    </div>
  </header>        
</template>           

<script>

import { mapGetters } from "vuex";
import { Slide } from "vue-burger-menu";
import RwvMenu from "@/components/Menu";
export default {
  name: "RwvHeader",
  props: {
    categories: Array
  },
  components: {
    Slide,   
    RwvMenu
  },
  computed: {
    ...mapGetters(["currentUser", "isAuthenticated"])
  }
};
</script>

<style>
.bm-burger-button {
  display: none;
}
</style>

